import { render } from "./BaseForm.vue?vue&type=template&id=5c700103&scoped=true"
import script from "./BaseForm.vue?vue&type=script&lang=js"
export * from "./BaseForm.vue?vue&type=script&lang=js"

import "./BaseForm.vue?vue&type=style&index=0&id=5c700103&lang=scss"
import "./BaseForm.vue?vue&type=style&index=1&id=5c700103&scoped=true&lang=scss"

import exportComponent from "/srv/sites/eservice.talronbatt.co.il/api/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c700103"]])

export default __exports__